<template>
  <div class="card">
    <div class="card-body">
      <div class="custom-search d-flex justify-content">
        <div>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="button"
            variant="primary"
            @click="$router.push({ name: 'organizer-page', params: { id: 'new' } })"
          >
            Новый организатор
          </b-button>
        </div>

        <div class="search-container">
          <b-form-group>
            <div class="d-flex align-items-center">
              <label class="mr-1">Название</label>
              <b-form-input
                v-model="filterText"
                placeholder="Поиск по названию"
                type="text"
                class="d-inline-block"
              />
            </div>
          </b-form-group>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <span v-if="props.column.field === 'action'">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

              <router-link
                :to="{ name: 'organizer-page', params: { id: props.row.id } }"
                class="edit-button"
              >
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Редактировать</span>
              </router-link>

              <b-dropdown-item
                v-b-modal.modal-primary
                variant="outline-primary"
                @click="organizerToDelete = props.row.id"
              >
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Удалить</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>

      <infinite-loading
        spinner="bubbles"
        @infinite="infiniteScroll"
      >
        <div slot="no-more" />
        <div slot="no-results" />
      </infinite-loading>
    </div>

    <div>
      <div class="demo-inline-spacing" />
      <b-modal
        id="modal-primary"
        v-model="modalIsOpen"
        ok-only
        ok-title="Отмена"
        modal-class="modal-primary"
        centered
        title="Удаление"
      >
        <div>Вы действительно хотите удалить организатора?</div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          class="mt-1"
          variant="primary"
          @click="deleteItem(organizerToDelete)"
        >
          Удалить
        </b-button>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BModal,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import InfiniteLoading from 'vue-infinite-loading'
import crudModule from '../../libs/crud_module'

const organizersModule = crudModule({
  entity_name: 'organizers',
})

export default {
  components: {
    VueGoodTable,
    BFormGroup,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BButton,
    BModal,
    InfiniteLoading,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      skipCount: 0,
      maxResultCount: 20,
      rows: [],
      modalIsOpen: false,
      organizerToDelete: null,
      filterText: '',
      sorting: 'id DESC',
      columns: [
        { label: 'ID', field: 'id' },
        { label: 'Название', field: 'name' },
        { label: 'Телефон', field: 'phone' },
        { label: 'Действие', field: 'action' },
      ],
      _searchDebounceTimer: null,
    }
  },
  watch: {
    filterText() {
      if (this._searchDebounceTimer) clearTimeout(this._searchDebounceTimer)
      this._searchDebounceTimer = setTimeout(() => {
        this.resetAndReload()
      }, 300)
    },
  },
  async created() {
    await this.resetAndReload()
  },
  methods: {
    async resetAndReload() {
      this.skipCount = 0
      const payload = {
        skipCount: 0,
        maxResultCount: this.maxResultCount,
        sorting: this.sorting,
        filterText: this.filterText || undefined,
      }
      const response = await organizersModule.fetchItems(payload)
      this.rows = (response.data && (response.data.rows || response.data.items)) || []
      this.skipCount = this.maxResultCount
    },
    async infiniteScroll($state) {
      try {
        const payload = {
          skipCount: this.skipCount,
          maxResultCount: this.maxResultCount,
          sorting: this.sorting,
          filterText: this.filterText || undefined,
        }
        const res = await organizersModule.fetchItems(payload)
        const nextRows = (res.data && (res.data.rows || res.data.items)) || []
        if (nextRows.length > 0) {
          this.rows.push(...nextRows)
          this.skipCount += this.maxResultCount
          $state.loaded()
        } else {
          $state.complete()
        }
      } catch (e) {
        $state.complete()
      }
    },
    async deleteItem(id) {
      if (!id) return
      await organizersModule.deleteItem(id)
      await this.resetAndReload()
      this.modalIsOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-search {
  justify-content: space-between;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>

<style lang="scss">
.edit-button {
  padding: 0.65rem 1.28rem;
  display: flex;
  align-items: center;

  &:hover {
    background-color: rgba(115, 103, 240, 0.12);
  }
}

@import '@core/scss/vue/libs/vue-good-table.scss';
</style>

